export const categories = [
  {
    id: 1,
    name: '明星八卦',
    slug: 'mingxing-bagua',
    icon: 'ri-star-line',
    count: 1286,
    description: '最新明星八卦爆料视频，涵盖娱乐圈热门话题与私密爆料',
  },
  {
    id: 2,
    name: '网红爆料',
    slug: 'wanghong-baoliao',
    icon: 'ri-live-line',
    count: 953,
    description: '网红圈最新爆料视频，揭露网络红人不为人知的另一面',
  },
  {
    id: 3,
    name: '社会热点',
    slug: 'shehui-redian',
    icon: 'ri-fire-line',
    count: 2104,
    description: '社会热点事件深度爆料视频，紧跟时事新闻动态',
  },
  {
    id: 4,
    name: '影视娱乐',
    slug: 'yingshi-yule',
    icon: 'ri-film-line',
    count: 867,
    description: '影视娱乐圈内幕爆料视频，独家揭秘幕后故事',
  },
  {
    id: 5,
    name: '综艺节目',
    slug: 'zongyi-jiemu',
    icon: 'ri-tv-line',
    count: 642,
    description: '综艺节目录制现场爆料，幕后花絮独家视频',
  },
  {
    id: 6,
    name: '直播事件',
    slug: 'zhibo-shijian',
    icon: 'ri-vidicon-line',
    count: 531,
    description: '直播平台热门事件视频合集，主播翻车与意外瞬间',
  },
  {
    id: 7,
    name: '体育圈',
    slug: 'tiyu-quan',
    icon: 'ri-basketball-line',
    count: 418,
    description: '体育圈内幕与运动员私生活爆料视频',
  },
  {
    id: 8,
    name: '科技圈',
    slug: 'keji-quan',
    icon: 'ri-smartphone-line',
    count: 375,
    description: '科技行业爆料视频，产品内幕与行业潜规则揭秘',
  },
];

export const videos = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度三小时全程曝光',
    description: '近日，有媒体拍到某当红顶流男星深夜与一名神秘女子在某五星级酒店共处三小时。据知情人士透露，该女子并非圈内人士，两人疑似已秘密交往数月。视频中清晰可见两人先后进入酒店，全程举止亲密。此消息一出立即引发网友热议，粉丝群体反应激烈。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20concept%2C%20dark%20atmosphere%2C%20paparazzi%20style%20photography%20of%20celebrity%20walking%20into%20luxury%20hotel%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20moody%20tones%2C%20urban%20night%20scene%2C%20warm%20golden%20accents%2C%20mysterious%20vibe&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    views: 1258000,
    duration: '03:25',
    date: '2026-08-03',
    featured: true,
    hot: true,
    content: '<p>近日，娱乐圈再爆重磅消息。据可靠渠道获悉，某当红顶流男星被拍到深夜与一名神秘女子在某五星级酒店密会。</p><p>从曝光的视频来看，该男星于当晚十点左右抵达酒店，全程戴着口罩和帽子，显得十分谨慎。约十五分钟后，一名身材高挑的女子也进入同一家酒店。</p><p>据酒店内部人士透露，两人在酒店内共处约三小时，期间曾通过酒店内部通道进出，疑似为避人耳目。直到凌晨一点左右，两人才先后离开。</p><p>有知情人士向记者透露，该女子并非娱乐圈人士，而是一名从事金融行业的白领。两人据说已秘密交往数月，但一直未对外公开。</p><p>截至目前，该男星方面尚未对此事作出回应。粉丝群体对此反应不一，有人表示祝福，也有人情绪激动要求工作室澄清。</p>',
    tags: ['顶流男星', '恋情曝光', '酒店密会', '娱乐圈', '独家爆料'],
  },
  {
    id: 2,
    title: '知名女星直播翻车现场！素颜出镜暴怒怼黑粉，金句频出太精彩',
    description: '某知名女星近日在直播中因不堪黑粉骚扰当场暴怒，素颜出镜回怼金句频出。直播片段在各大平台疯传，网友纷纷围观评论，有人力挺有人质疑，话题热度持续攀升。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20female%20streamer%20angry%20reaction%20during%20live%20stream%2C%20dramatic%20studio%20lighting%2C%20close-up%20camera%20angle%2C%20emotional%20expression%2C%20modern%20streaming%20setup%2C%20warm%20ambient%20light%2C%20professional%20microphone%20visible%2C%20intense%20atmosphere&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    category: '直播事件',
    categorySlug: 'zhibo-shijian',
    views: 987000,
    duration: '05:12',
    date: '2026-08-02',
    featured: true,
    hot: true,
    content: '<p>本周，知名女星在个人社交平台进行日常直播时，遭遇大批黑粉涌入刷屏恶意评论。起初该女星选择无视，但黑粉变本加厉，最终导致女星当场爆发。</p><p>令人意外的是，该女星当时素颜出镜，没有任何妆容修饰。她在直播中直接对着镜头怒怼黑粉，言辞犀利，金句频出，让现场工作人员都看呆了。</p><p>"我靠自己的努力走到今天，你们这些键盘侠有什么资格在这里指指点点？"该女星在直播中情绪激动地说道。</p><p>直播片段被网友录屏后在各大社交平台疯传，相关话题迅速登上热搜。大部分网友对该女星表示支持和理解，认为明星也有生气的权利。但也有部分网友质疑其是否在炒作。</p>',
    tags: ['知名女星', '直播翻车', '素颜出镜', '怒怼黑粉', '热搜话题'],
  },
  {
    id: 3,
    title: '网红圈大地震！多位千万粉丝博主被曝造假数据，平台已介入调查',
    description: '网红圈发生大地震！近日有多位拥有千万粉丝的头部博主被曝涉嫌数据造假，包括刷量、买粉等行为。相关平台已发布声明称将介入调查，涉事博主账号可能面临封禁处理。',
    thumbnail: 'https://readdy.ai/api/search-image?query=data%20analytics%20dashboard%20with%20red%20warning%20indicators%2C%20social%20media%20metrics%20display%2C%20dramatic%20dark%20background%2C%20fraud%20detection%20concept%2C%20modern%20tech%20interface%2C%20warm%20warning%20lights%2C%20investigative%20journalism%20style&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    views: 2150000,
    duration: '08:45',
    date: '2026-08-01',
    featured: true,
    hot: false,
    content: '<p>近日，网红圈爆发重大丑闻。据行业内部人士爆料，多位粉丝数量超过千万的头部网红博主存在严重的数据造假行为。</p><p>爆料指出，这些博主通过购买虚假粉丝、刷评论互动、伪造直播观看人数等手段，人为制造高人气假象，从而获取更多商业合作机会和高额广告费用。</p><p>据悉，涉事博主的造假行为已持续相当长时间，涉及金额可能高达数千万。目前各大社交平台已发布声明，表示将严肃调查此事，一旦查实将对涉事账号进行处罚，包括但不限于限流、降权甚至永久封禁。</p><p>此消息一出，广告商和品牌方纷纷表示关注，部分品牌已紧急暂停与涉事博主的合作。业内人士分析，此次事件可能会对整个网红经济生态产生深远影响。</p>',
    tags: ['网红圈', '数据造假', '千万粉丝', '平台调查', '网红经济'],
  },
  {
    id: 4,
    title: '某选秀节目导师内讧曝光！录制现场激烈争吵，节目组紧急暂停录制',
    description: '独家爆料！某热门选秀节目录制现场发生导师激烈争吵事件。据悉两位导师因对选手评价产生严重分歧，当场发生口角，导致节目组不得不紧急暂停录制。',
    thumbnail: 'https://readdy.ai/api/search-image?query=talent%20show%20stage%20with%20dramatic%20red%20spotlights%2C%20empty%20judges%20chairs%2C%20tense%20atmosphere%2C%20television%20studio%20set%2C%20professional%20lighting%20rig%2C%20behind%20the%20scenes%20production%2C%20dramatic%20shadows%2C%20warm%20stage%20lighting&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    views: 1560000,
    duration: '04:38',
    date: '2026-08-03',
    featured: true,
    hot: true,
    content: '<p>据现场工作人员独家透露，某热门选秀节目在最新一期录制过程中发生了令人震惊的导师内讧事件。</p><p>事件起因是两位导师对一名参赛选手的表现评价产生了严重分歧。一位导师认为该选手表现出色应该晋级，而另一位导师则直言其表演毫无亮点。两人的争论逐渐升级，最终演变成激烈的争吵。</p><p>现场观众描述，两位导师的争吵持续了将近十分钟，言辞激烈，甚至涉及对彼此专业能力的质疑。节目组导演不得不多次喊停，最终决定紧急暂停当天的录制。</p><p>据知情人士透露，这两位导师之间早有矛盾，此次只是矛盾的一次集中爆发。节目组目前正在紧急协调，希望能尽快恢复录制。该期节目的播出时间可能会因此推迟。</p>',
    tags: ['选秀节目', '导师内讧', '录制现场', '激烈争吵', '节目暂停'],
  },
  {
    id: 5,
    title: '体育明星深夜酒吧狂欢视频流出！与多名女子亲密互动引争议',
    description: '某知名体育明星被拍到深夜在某高档酒吧与多名女子亲密互动。视频中该运动员状态兴奋，行为出格。视频流出后在网上引发轩然大波，其经纪团队尚未回应。',
    thumbnail: 'https://readdy.ai/api/search-image?query=upscale%20nightclub%20interior%20with%20warm%20amber%20lighting%2C%20luxury%20bar%20atmosphere%2C%20blurred%20people%20partying%2C%20exclusive%20VIP%20area%2C%20dramatic%20mood%20lighting%2C%20nightlife%20photography%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    category: '体育圈',
    categorySlug: 'tiyu-quan',
    views: 1890000,
    duration: '02:55',
    date: '2026-08-02',
    featured: false,
    hot: true,
    content: '<p>近日，一段体育明星深夜在酒吧狂欢的视频在网络上疯传。视频中，该知名运动员在某高档酒吧的VIP包间内与多名女子举止亲密，状态明显兴奋。</p><p>据拍摄者称，当时已是凌晨两点左右，该运动员一行人在酒吧消费金额不菲。视频中可以清晰看到其与多名女子推杯换盏，互动亲密，行为尺度颇大。</p><p>该视频一经流出立即在网上引发巨大争议。不少网友对该运动员的行为表示失望，认为作为公众人物应该注意自身形象。也有粉丝为其辩护，称运动员也是普通人，有社交自由。</p><p>截至目前，该运动员的经纪团队尚未就此事作出任何回应。据悉其所在俱乐部已内部了解情况，可能会对其作出相应处理。</p>',
    tags: ['体育明星', '酒吧狂欢', '视频流出', '争议', '亲密互动'],
  },
  {
    id: 6,
    title: '科技大佬私密饭局录音曝光！讨论行业机密信息量巨大',
    description: '一段科技行业大佬私密饭局的录音近日意外流出，录音中多位行业顶级人物讨论了多个敏感话题，包括未公开的产品计划、行业并购传闻以及对竞争对手的评价等。',
    thumbnail: 'https://readdy.ai/api/search-image?query=exclusive%20private%20dining%20room%20in%20luxury%20Chinese%20restaurant%2C%20elegant%20round%20table%20with%20fine%20dining%20setup%2C%20warm%20ambient%20lighting%2C%20business%20meeting%20atmosphere%2C%20discreet%20and%20intimate%20setting%2C%20high-end%20interior%20design&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    category: '科技圈',
    categorySlug: 'keji-quan',
    views: 2340000,
    duration: '12:20',
    date: '2026-08-01',
    featured: true,
    hot: true,
    content: '<p>日前，一段据称是科技行业多位大佬私密饭局的录音在网络上意外流出，引发轩然大波。录音时长超过12分钟，信息量巨大。</p><p>在这段录音中，可以听到多位行业顶级人物在饭局上畅所欲言，讨论了多个极其敏感的话题。其中包括某科技巨头尚未对外公开的新产品计划、行业内的重大并购传闻，以及对多个竞争对手毫不留情的评价。</p><p>录音中透露的未公开产品信息如果属实，将对整个行业格局产生重大影响。多个涉及的企业在录音流出后股价出现明显波动。</p><p>截至目前，录音中涉及的各方均未对此事作出正式回应。法律专家表示，私密谈话被录音并公开传播可能涉及法律问题，录音的发布者可能面临法律追责。</p>',
    tags: ['科技大佬', '私密饭局', '录音曝光', '行业机密', '未公开产品'],
  },
  {
    id: 7,
    title: '某影视剧组拍摄现场突发意外！演员受伤送医，剧组停工损失惨重',
    description: '某正在紧张拍摄中的大型影视剧组突发意外事故，一名主要演员在拍摄动作戏时不慎受伤，被紧急送往医院。剧组被迫停工，据悉每日经济损失高达数百万。',
    thumbnail: 'https://readdy.ai/api/search-image?query=film%20set%20with%20emergency%20lights%2C%20movie%20production%20equipment%20scattered%2C%20medical%20team%20arriving%2C%20dramatic%20lighting%2C%20action%20scene%20setup%20with%20wires%20and%20cameras%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20chaos&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    category: '影视娱乐',
    categorySlug: 'yingshi-yule',
    views: 1780000,
    duration: '03:50',
    date: '2026-07-31',
    featured: false,
    hot: false,
    content: '<p>据前方记者最新消息，某大型影视剧组在拍摄现场突发意外事故。一名主要演员在亲自上阵拍摄高难度动作戏时不幸受伤。</p><p>现场目击者描述，当时正在拍摄一场激烈的打斗戏份，演员按照导演要求完成一组高难度动作时突然失去平衡，从两米多高的位置摔落。现场工作人员立即上前施救，并拨打了急救电话。</p><p>受伤演员被紧急送往附近医院接受治疗，目前伤情尚不明朗。据医院方面透露，该演员可能伤及腿部，需要进行进一步检查。</p><p>剧组方面已宣布暂停拍摄，等待该演员康复后再定复工时间。业内人士估算，剧组每日停工造成的经济损失高达数百万元，加上后续的进度调整，整体影响不容小觑。</p>',
    tags: ['影视剧组', '拍摄意外', '演员受伤', '剧组停工', '动作戏'],
  },
  {
    id: 8,
    title: '网红情侣分手大战升级！互曝黑料晒聊天记录，粉丝吃瓜吃到撑',
    description: '知名网红情侣分手大战持续升级！双方在社交平台互相爆料，晒出大量私密聊天记录截图。两人各执一词，粉丝站队互撕，瓜越吃越大。',
    thumbnail: 'https://readdy.ai/api/search-image?query=social%20media%20drama%20concept%2C%20two%20phones%20displaying%20chat%20messages%2C%20split%20screen%20composition%2C%20warm%20ambient%20lighting%2C%20relationship%20conflict%20theme%2C%20modern%20smartphone%20with%20notification%20bubbles%2C%20dramatic%20contrast&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    views: 3100000,
    duration: '06:40',
    date: '2026-08-03',
    featured: true,
    hot: true,
    content: '<p>网红圈的年度分手大戏正在上演！一对拥有千万粉丝的知名网红情侣近日官宣分手后，事态不但没有平息反而持续升级。</p><p>女方率先在社交平台发文，暗指男方在恋爱期间存在不忠行为。随后男方迅速反击，直接晒出多张两人私密聊天记录截图，指控女方长期控制欲过强、情绪不稳定。</p><p>双方你来我往，互不相让。女方随后也晒出聊天记录反击，曝光了男方更多不为人知的私生活细节。短短24小时内，双方已发布了超过20条互相攻击的内容。</p><p>这场分手大战吸引了大量网友围观吃瓜，相关话题连续多日占据热搜榜。双方粉丝也纷纷下场站队互撕，场面一度十分混乱。</p>',
    tags: ['网红情侣', '分手大战', '互曝黑料', '聊天记录', '吃瓜', '粉丝互撕'],
  },
  {
    id: 9,
    title: '某知名综艺被曝剧本造假！参与者爆料一切都是提前安排好的',
    description: '一档深受观众喜爱的知名综艺节目近日被曝存在严重剧本造假。一位自称参与过节目录制的内部人士爆料称，节目中的感人故事和激烈冲突全都是编剧提前设计好的。',
    thumbnail: 'https://readdy.ai/api/search-image?query=television%20script%20and%20storyboard%20on%20production%20table%2C%20variety%20show%20behind%20the%20scenes%2C%20studio%20equipment%20in%20background%2C%20dramatic%20lighting%2C%20papers%20scattered%2C%20cinematic%20documentary%20style%2C%20warm%20amber%20tones&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    category: '综艺节目',
    categorySlug: 'zongyi-jiemu',
    views: 1650000,
    duration: '07:15',
    date: '2026-07-30',
    featured: false,
    hot: false,
    content: '<p>一档以"真实"著称的热门综艺节目近日陷入剧本造假丑闻。一位自称参与过该节目多期录制的内部人士向媒体爆料，揭露了节目背后不为人知的运作方式。</p><p>据该爆料人透露，节目中那些令观众感动落泪的选手故事，其实大部分都是编剧团队预先设计好的。节目组会事先对选手进行深度采访，然后根据选手的背景编造出更有戏剧性的故事线。</p><p>更令人震惊的是，节目中那些引发热议的选手冲突和导师争议，也全是提前安排好的"剧本"。每位参与者在录制前都会收到一份详细的"人物设定"和"剧情走向"。</p><p>此爆料一出，立即引发观众强烈反响。许多忠实观众表示感到被欺骗，要求节目组给出解释。目前该节目组尚未对此事作出回应。</p>',
    tags: ['综艺节目', '剧本造假', '内部爆料', '观众被骗', '综艺黑幕'],
  },
  {
    id: 10,
    title: '某电商平台头部主播涉嫌虚假宣传被立案调查！直播间商品质量问题曝光',
    description: '某电商平台头部带货主播因涉嫌虚假宣传被市场监管部门立案调查。其直播间销售的多款商品被消费者投诉存在严重质量问题，涉及金额巨大。',
    thumbnail: 'https://readdy.ai/api/search-image?query=e-commerce%20live%20streaming%20studio%20with%20products%20displayed%2C%20investigation%20concept%2C%20red%20warning%20symbols%2C%20consumer%20complaints%20visualization%2C%20modern%20streaming%20equipment%2C%20dramatic%20lighting%2C%20professional%20setup&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    views: 2780000,
    duration: '05:55',
    date: '2026-08-02',
    featured: false,
    hot: true,
    content: '<p>直播带货行业再次曝出重大负面新闻。某电商平台拥有数千万粉丝的头部带货主播近日因涉嫌虚假宣传被市场监管部门正式立案调查。</p><p>据了解，该主播在直播中多次对商品功效进行夸大宣传，声称某护肤品具有"医美级效果"、某保健品可以"三天见效"等，严重误导消费者。此外，其直播间销售的多款商品被大量消费者投诉存在质量问题。</p><p>市场监管部门在接到大量消费者投诉后展开了调查，发现该主播的直播带货行为涉嫌违反《广告法》和《消费者权益保护法》的相关规定。目前案件正在进一步调查中。</p><p>此事件再次引发公众对直播带货行业规范化的讨论。业内专家呼吁加强对直播带货的监管力度，保护消费者合法权益。</p>',
    tags: ['头部主播', '虚假宣传', '立案调查', '质量问题', '直播带货'],
  },
  {
    id: 11,
    title: '某知名导演潜规则女演员丑闻曝光！多位女星勇敢站出来发声',
    description: '娱乐圈再爆潜规则丑闻！某知名导演被多位女演员联合指控利用职务之便进行不当行为。事件持续发酵，更多受害者选择站出来发声，引发行业震动。',
    thumbnail: 'https://readdy.ai/api/search-image?query=film%20director%20chair%20empty%20on%20dark%20movie%20set%2C%20dramatic%20spotlight%2C%20symbolic%20metoo%20concept%2C%20powerful%20visual%20metaphor%2C%20cinematic%20lighting%20with%20shadows%2C%20warm%20dramatic%20contrast%2C%20film%20industry%20theme&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    views: 3560000,
    duration: '09:30',
    date: '2026-08-03',
    featured: true,
    hot: true,
    content: '<p>娱乐圈再掀波澜。某知名导演近日被多位女演员集体指控利用职务之便进行不当行为，事件迅速发酵成为全网关注的焦点。</p><p>首位发声的女演员在社交媒体上发布长文，详细描述了自己在多年前与该导演合作期间遭受的不公正对待。她表示，当时因为害怕影响事业而选择沉默，但多年来的心理创伤让她最终决定站出来。</p><p>在她的带动下，短短几天内又有数位女演员先后发声，描述了类似的经历。这些指控的时间跨度超过十年，显示出严重的行为模式。</p><p>此事件引发了行业内的广泛讨论，多个影视协会和行业组织发表声明，呼吁建立更完善的行业规范和举报机制，保护从业人员的合法权益。</p>',
    tags: ['知名导演', '潜规则', '女演员', '丑闻曝光', '行业震动', 'MeToo'],
  },
  {
    id: 12,
    title: '热门手游策划内部群聊天曝光！下版本内容提前泄露，玩家炸锅了',
    description: '某热门手机游戏策划团队的内部工作群聊天记录意外流出，大量下个版本的未公开内容被提前曝光。新角色、新玩法等核心信息一览无余，玩家社区瞬间沸腾。',
    thumbnail: 'https://readdy.ai/api/search-image?query=mobile%20game%20development%20concept%20art%20leaked%2C%20game%20design%20documents%20on%20screen%2C%20dark%20tech%20office%20environment%2C%20dramatic%20blue%20screen%20glow%2C%20secret%20document%20vibe%2C%20gaming%20industry%20theme%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    category: '科技圈',
    categorySlug: 'keji-quan',
    views: 1920000,
    duration: '04:50',
    date: '2026-08-01',
    featured: false,
    hot: false,
    content: '<p>游戏圈发生了一起重大泄露事件。某热门手机游戏策划团队的内部工作群聊天记录意外流出，大量下个版本的未公开核心内容被提前曝光。</p><p>泄露的聊天记录中包含了新版本的多项核心内容：两个全新角色的详细技能设计、一个全新玩法模式的完整规则说明、以及多款限定皮肤的预览图。这些内容原计划在下月的版本发布会上才对外公布。</p><p>消息一出，游戏玩家社区立刻炸开了锅。有人对新内容表示期待，也有人对提前泄露表示不满，认为破坏了惊喜感。更有玩家开始根据泄露信息研究新版本的策略和搭配。</p><p>游戏官方在事发后紧急发布声明，确认了部分泄露内容的真实性，同时表示将追究泄露者的法律责任。但这次泄露事件对游戏运营节奏的影响已经不可避免。</p>',
    tags: ['热门手游', '内部泄露', '下版本内容', '玩家社区', '游戏策划'],
  },
];

export const siteInfo = {
  name: '黑料视频',
  slogan: '最新最全的吃瓜爆料视频平台',
  description: '黑料视频是国内领先的娱乐资讯视频聚合平台，致力于为用户提供最新、最全、最高清的吃瓜爆料视频。我们聚合全网优质内容，涵盖明星八卦、网红爆料、社会热点、影视娱乐等多个领域，让您足不出户尽览天下爆料。',
  founded: '2020年',
  email: 'contact@heiliaoshipin.com',
  phone: '400-888-8888',
  address: '北京市朝阳区传媒产业园A座',
  reputation: [
    { label: '日活跃用户', value: '500万+' },
    { label: '视频总量', value: '10万+' },
    { label: '合作媒体', value: '200+' },
    { label: '用户好评率', value: '98.5%' },
  ],
  faqs: [
    { question: '黑料视频的内容来源是什么？', answer: '黑料视频聚合全网优质视频内容，所有视频均来自合作媒体和公开平台。我们拥有专业的编辑团队，对内容进行审核和筛选，确保为用户提供真实、有价值的爆料视频。' },
    { question: '如何在黑料视频上观看视频？', answer: '您可以直接访问黑料视频官网，无需注册即可免费观看所有视频内容。我们支持PC端和移动端访问，高清流畅的播放体验让您随时随地畅享最新爆料。' },
    { question: '黑料视频的内容多久更新一次？', answer: '黑料视频保持7×24小时不间断更新，每天都有大量新鲜内容上线。我们的编辑团队全天候关注热点事件，确保您第一时间看到最新爆料。' },
    { question: '是否可以在黑料视频上发布自己的视频？', answer: '目前黑料视频作为聚合平台，暂不支持用户自行上传视频。如果您有优质内容希望在我们平台展示，可以通过联系我们页面提交合作申请。' },
    { question: '在黑料视频上观看视频是否需要付费？', answer: '黑料视频始终坚持免费服务理念，所有视频内容均可免费观看，无需任何付费。我们致力于打造一个开放、免费的爆料视频分享平台。' },
  ],
};